import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TrialLinkService implements OnDestroy {
    private readonly links = ['https://www.socialtalent.com/get-in-touch'];
    private readonly subscriptions = new Subscription();

    get link() {
        return this.links[Math.floor(Math.random() * this.links.length)];
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
